<template>
  <div>
    <el-dialog title="添加秒杀订单" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="1000px">
      <div v-loading="fullscreenLoading" class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
        <div class="reimbursement">
          <el-form ref="dataForm" :model="form" label-position="right" label-width="120px">
            <template>
              <el-form-item label="下单人信息：" prop="customerId" :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
                <el-select v-model="form.customerId" value-key="value" placeholder="根据手机号/姓名搜索" filterable clearable remote :remote-method="searchUsers" :loading="loading" @change="getUserAddr">
                  <el-option v-for="(it,idx) in userList" :label="`${it.name}(${it.pho})${it.levelName}`" :key="idx" :value="it.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收货地址：" prop="addressId" :rules="[{ required: true, message: '请选择收货地址', trigger: 'change' }]">
                <div class="flexs">
                  <el-select v-model="form.addressId" placeholder="请选择收货地址" clearable>
                    <el-option v-for="(it,idx) in userAddrList" :key="idx" :label="it.allAddr" :value="it.id"></el-option>
                  </el-select>
                  <el-button type="primary" @click="addAddress">新增地址</el-button>
                </div>
              </el-form-item>
              <el-form-item label="随货同行单：" prop="customerIdcard" :rules="[{ required: true, message: '请选择随货同行单', trigger: 'change' }]">
                <el-select v-model="form.customerIdcard" placeholder="请选择随货同行单" clearable>
                  <el-option v-for="(it,idx) in customerCertificatesList" :key="idx" :label="it.companyName" :value="it.companyName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注：" class="width100">
                <el-input v-model="form.orderRemark" placeholder="请输入备注" />
              </el-form-item>
              <el-form-item label="秒杀商品：" prop="goodsSeckillId" class="width100" :rules="[{ required: true, message: '请选择秒杀商品', trigger: 'change' }]">
                <div style="display: flex">
                  <el-select v-model="form.goodsSeckillId" filterable placeholder="请选择" @change="handleChange()">
                    <el-option v-for="it in sysGoods" :key="it.id" :label="it.name + (it.aliasName ? ' [' + it.aliasName + ']' : '')" :value="it.id"></el-option>
                  </el-select>
                  <el-input-number v-model.number="form.goodsSeckillCount" :step="1" step-strictly style="margin-left:5px" :min="1" :precision="0"></el-input-number>
                </div>
              </el-form-item>
              <div v-if="activityList.length">
                <el-form-item label="正价商品：" class="width100">
                  共{{activityList.length}}件
                  <div class="table-list">
                    <div class="spec-head">
                      <div class="sp-col">商品名称</div>
                      <div class="sp-col">数量</div>
                    </div>
                    <div class="spec-item" v-for="(item, index) in activityList" :key="index">
                      <el-form-item class="sp-col">{{item._sysGoodsPO && item._sysGoodsPO.name || ''}}</el-form-item>
                      <el-form-item class="sp-col">{{item.num * form.goodsSeckillCount}}</el-form-item>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="activityListSend.length">
                <el-form-item label="赠送商品：" class="width100">
                  共{{activityListSend.length}}件
                  <div class="table-list">
                    <div class="spec-head">
                      <div class="sp-col">商品名称</div>
                      <div class="sp-col">数量</div>
                    </div>
                    <div class="spec-item" v-for="(item, index) in activityListSend" :key="index">
                      <el-form-item class="sp-col">{{item._sysGoodsPO && item._sysGoodsPO.name || ''}}</el-form-item>
                      <el-form-item class="sp-col">{{item.num * form.goodsSeckillCount}}</el-form-item>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="发货方式："class="width100" prop="receiptType" :rules="[{ required: true, message: '请选择发货方式', trigger: 'change' }]">
                <el-radio-group v-model="form.receiptType" @change="handleReceiptTypeChange">
                  <el-radio :label="10" v-if="currentGoods && currentGoods.isOpenMailing">快递邮寄<br /></el-radio>
                  <el-radio :label="20" v-if="currentGoods && currentGoods.isOpenSelfPickup">到店自提<br /></el-radio>
                </el-radio-group>
                </el-form-item>
                <el-form-item label="自提地址：" class="width100" prop="pickupAddressId" v-if="form.receiptType === 20" :rules="[{ required: true, message: '请选择自提地址', trigger: 'change' }]">
                  <el-select v-model="form.pickupAddressId" placeholder="请选择自提地址" clearable>
                    <el-option 
                      v-for="item in pickupAddressList" 
                      :key="item.id" 
                      :label="`${item.name || ''} - ${item.address || ''}`" 
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="frBox" v-if="form.receiptType === 10">
                <el-form-item label="快递类型：" class="width50" prop="expressId" :rules="[{ required: true, message: '请选择快递类型', trigger: 'change' },]">
                  <el-select v-model="form.expressId" placeholder="请选择快递类型" clearable @change="changeExpress">
                    <el-option v-for="(it,idx) in deliveryList" :key="idx" :label="it.name" :value="it.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="邮费：" class="width50" prop="freight">
                  <el-input v-model="form.freight" placeholder="请输入邮费" :disabled="!form.expressId || isPostage" />
                </el-form-item>
              </div>
              <el-form-item label="账户余额：" class="width100">
                <el-input v-model="accountBalance" disabled />
              </el-form-item>
            </template>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="doCreate()">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <addressVue ref="addressVue" @created="createAddr" />
  </div>
</template>
<script>
import goodsOrderApi from "@/api/order/goodsOrder";
import sysGoodsApi from "@/api/sys/sysGoods";
import { Subtr, accMul, formatDateStr, getDateAfterNDays } from "@/utils/index";
import addressVue from './address.vue'
function initFormBean() {
  const formBean = {
    customerId: undefined,
    addressId: undefined,
    customerIdcard: undefined,
    orderRemark: undefined,
    expressId: undefined,
    freight: undefined,
    goodsSeckillId: undefined,
    goodsSeckillCount: 1,
    orderPayType: undefined,
    receiptType: undefined,
    pickupAddressId: undefined,
  }
  return formBean
}
export default {
  components: { addressVue },
  data() {
    return {
      deliveryList: [],
      userList: [],
      userAddrList: [],
      customerCertificatesList: [],
      sysGoods: [],
      form: initFormBean(),
      formVisible: false,
      fullscreenLoading: false,
      isRepSub: false,
      accountBalance: null,
      allMoney: null,
      activityList: [],
      activityListSend: [],
      isPostage: 0,
      loading: false, // 添加loading属性用于el-select的loading状态
      pickupAddressList: [] // 自提地址列表
    };
  },
  computed: {
    // 获取当前选中的商品信息
    currentGoods() {
      if (!this.form.goodsSeckillId) return null
      return this.sysGoods.find(item => item.id === this.form.goodsSeckillId) || null
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 150;
    this.getDeliveryList();

  },
  methods: {
    addAddress() {
      if (!this.form.customerId) return this.$message('请选择下单人')
      let find = this.userList.find(item => item.id === this.form.customerId)
      this.$refs.addressVue.handleShow(find)
    },
    createAddr(id) {
      this.getUserAddr(id)
    },
    getUserWallet() {
      goodsOrderApi.userWallet(this.form.customerId).then(res => {
        this.accountBalance = res.data.balance || 0
      })
    },
    resetForm() {
      this.activityList = []
      this.activityListSend = []
      this.form = initFormBean()
      // 确保 goodsSeckillCount 是数字类型
      this.form.goodsSeckillCount = 1
    },
    getDeliveryList(row) {
      let orderType = "2";
      goodsOrderApi.getDeliveryList({ orderType, isEnable: 1 }).then((res) => {
        let { list } = res.data;
        this.deliveryList = list;
      });
    },
    searchUsers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          this.getUserList(query)
        }, 500);
      } else {
        this.userList = [];
      }
    },
    getUserList(query) {
      goodsOrderApi.getUserList({ state: 1, isDeparted: 0, nameOrPho: query, pageNo: 1, pageSize: 100 }).then((res) => {
        let { list } = res.data;
        let arr = []
        list && list.forEach(item => {
          let { id, name, pho, userId, clevel } = item.customer;
          arr.push({ id, name, pho, userId, levelName: item.customerLevel.name, clevel })
        })
        this.userList = arr;
      });
    },
    changeExpress() {
      let { expressId, addressId, goodsSeckillId } = this.form;
      if (!goodsSeckillId) return this.$message('请选择秒杀商品')
      let find = this.sysGoods.find(item => item.id === goodsSeckillId)
      if (find && find.isPostage) return this.form.freight = 0
      if (expressId && addressId) {
        goodsOrderApi.freight({ expressId, addressId: addressId, money: this.allMoney, payType: 2 }).then(res => {
          this.form.freight = res.data;
        })
      }
    },

    handleCreate(row) {
      this.resetForm()
      this.isRepSub = false
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    // 选择事件
    getUserAddr(val) {
      let find = this.userList.find(item => item.id === val)
      goodsOrderApi.getUserAddrList({ userId: find.userId }).then((res) => {
        let { list } = res.data;
        if (list.length) {
          list.forEach((it) => {
            it.allAddr = it.country + it.province + it.city + it.district + it.detailedAddress;
          });
        }
        this.userAddrList = list;
      });
      goodsOrderApi.getCustomerCertificatesList(val).then((res) => {
        this.customerCertificatesList = res.data;
        this.form.addressId = undefined;
      });
      this.getUserWallet()
      this.getGoods()
    },
    searchKillGoods(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          this.getGoods(query)
        }, 500);
      } else {
        this.userList = [];
      }
    },
    getGoods(name) {
      if (!this.form.customerId) return this.$message('请选择下单人')
      let find = this.userList.find(item => item.id === this.form.customerId)
      goodsOrderApi.findKillGoods({ CLevel: find.clevel, name, pageNo: 1, pageSize: 100 }).then(({ data }) => {
        this.sysGoods = data.list;
      });
    },
    handleChange() {
      let { goodsSeckillId } = this.form
      let find = this.sysGoods.find((item) => item.id === goodsSeckillId)
      this.isPostage = find.isPostage
      this.allMoney = find.killMoney;
      //isGift 正价商品0 赠品商品1
      let arr = [], arr1 = []
      find.goodsPackageConfigPOS.forEach(item => {
        if (item.isGift) {
          arr.push(item)
        } else {
          arr1.push(item)
        }
      })
      this.activityList = arr1
      this.activityListSend = arr;
      // 获取自提地址列表
      this.pickupAddressList = find.pickupAddressList || []
      // 如果切换商品，清空自提地址选择
      this.form.pickupAddressId = undefined
      this.changeExpress()
    },
    handleReceiptTypeChange(value) {
      // 当切换发货方式时，清空自提地址选择
      if (value !== 20) {
        this.form.pickupAddressId = undefined
      }
      // 当切换到自提时，快递类型传null，邮费传0
      if (value === 20) {
        this.form.expressId = null
        this.form.freight = 0
      }
    },

    // 格式化商品数据
    formatGoodsData() {
      const settleGoodsDtos = this.activityList.map(item => ({
        buyNum: (item.num || 1) * this.form.goodsSeckillCount,
        goodsId: item._sysGoodsPO && item._sysGoodsPO.id || ''
      })).filter(item => item.goodsId)
      
      const sendSettleGoodsDtos = this.activityListSend.map(item => ({
        buyNum: (item.num || 1) * this.form.goodsSeckillCount,
        goodsId: item._sysGoodsPO && item._sysGoodsPO.id || ''
      })).filter(item => item.goodsId)
      
      return { settleGoodsDtos, sendSettleGoodsDtos }
    },
    // 添加订单
    doCreate() {
      if (this.fullscreenLoading) return;
      this.$refs["dataForm"].validate((valid) => {
        console.log(valid);
        if (valid) {
          this.submitForm()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitForm() {
      console.log(this.form)
      let query = { ...this.form };
      
      // 如果是自提，将选中的自提地址id存到addressId字段，快递类型传null，邮费传0
      if (query.receiptType === 20) {
        if (query.pickupAddressId) {
          query.addressId = query.pickupAddressId
        }
        query.expressId = null
        query.freight = 0
      }
      
      // 添加格式化后的商品数据
      const { settleGoodsDtos, sendSettleGoodsDtos } = this.formatGoodsData()
      query.settleGoodsDtos = settleGoodsDtos
      query.sendSettleGoodsDtos = sendSettleGoodsDtos
      
      if (this.isRepSub) return
      this.isRepSub = true
      this.fullscreenLoading = true;
      goodsOrderApi.bgAddKillOrder(query).then((res) => {
        if (res) {
          this.fullscreenLoading = false;
          this.formVisible = false;
          this.$emit('created')
        }
      }).catch(res => {
        this.fullscreenLoading = false;
        this.isRepSub = false
      });
    },
    closeDialog() {
      this.formVisible = false;
      this.fullscreenLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.reimbursement {
  padding: 0 20px;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.reimbursement {
  // padding: 0 20px;
}
.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}
.table-list {
  border: 1px solid #e4e4e4;

  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      flex-grow: 2;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #5dbde7;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.item-flex {
  display: flex;
  margin-bottom: 5px;
  .icon-box {
    display: inline-block;
    width: 60px;
    i {
      font-size: 20px;
      margin-left: 5px;
      cursor: pointer;
      font-weight: bold;
      color: #465c99;
    }
  }
}
.oper-icon {
  i {
    font-size: 16px;
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
    color: #465c99;
  }
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.hint {
  font-size: 12px;
  color: #878787;
  &.hint1 {
    padding-left: 10px;
    line-height: 18px;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-left: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
.title-box {
  margin-bottom: 10px;
  margin-right: 24px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 30px;
    &::before {
      content: '';
      position: absolute;
      left: 20px;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
  }
}
.table-list {
  border: 1px solid #e4e4e4;
  // margin: 0 35px 20px 50px;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      flex-grow: 2;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.frBox {
  display: flex;
  align-items: center;
  .width50 {
    width: 50% !important;
  }
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
.formMoney {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 20px;
  color: #e73f3f;
  .el-button {
    margin-top: 20px;
  }
}
.pays {
  font-size: 10px;
  color: #999;
}
.is-checked .pays {
  color: #999;
}
</style>
